export default "__VITE_ASSET__DmCXEELT__"